import axios from "axios";

export default async function commitObject(projectName, formName, document_id, data) {
    // old api => return await axios.post(`project/${projectName}/${formName}/add-document/${document_id}/commit`, data)
    return await axios.post(`/project/${projectName}/${formName}/archive-document/${document_id}/commit`, data)
}